import * as React from "react";
import {cloneElement, Component} from "react";

export class ArrowLinkSegmentWidget extends Component {
    render() {
        const Bottom = cloneElement(
            this.props.factory.generateLinkSegment(
                this.props.link,
                this.props.selected || this.props.link.isSelected(),
                this.props.path
            ),
            {
                ref: this.props.forwardRef
            }
        );

        return (
            <g>
                {Bottom}
            </g>
        );
    }
}
